import {Component} from 'react'
import Link from './links/RouterLink'
class Item extends Component {
    constructor(props) {
        super(props)
        this.hide = this.hide.bind(this)

    }
    hide() {
        this.props.onclick();
    }

    render() {
        return (
            <li onClick={this.hide}>
                <Link route={this.props.routeParams.route}  params={this.props.routeParams.params}>
                    {this.props.v}
                </Link>
            </li>
        )
    }
}




class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)
        this.toggle = this.toggle.bind(this)
        this.state = {
            isOpen: false
        }
    }

    title() {
        let res = this.props.title
        this.props.items.map(function(i) {
            if (i.selected) {
                res = i.v
            }
        })
        return res
    }
    show() {
        this.setState({ isOpen: true })
    }
    hide() {
        this.setState({ isOpen: false })
    }
    toggle() {
        this.setState({ isOpen: !this.state.isOpen})
    }

    list() {
        let items = this.props.items.map((i) => { return <Item key={i.k} {...i} routeParams={this.props.hrefParams(i.k)} onclick={this.hide}/> })
        return this.state.isOpen ? <ul>{items}</ul> : null
    }


    render() {
        return (
            <div onMouseLeave={this.hide} className="dropdown">
                <span className="icon" />
                <strong  onClick={this.toggle}>{this.title()}</strong>
                {this.list()}
            </div>
        )
    }
}

export default Dropdown



// WEBPACK FOOTER //
// components/Dropdown.js